import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('bg-white', 'shadow-sm');
        } else {
          header.classList.remove('bg-white', 'shadow-sm');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappMessage = encodeURIComponent(
    'Olá, Ana! Preciso de ajuda para desenquadrar do MEI. Pode me orientar sobre o processo?'
  );
  const whatsappLink = `https://api.whatsapp.com/send/?phone=554185113433&text=${whatsappMessage}`;

  const whatsappLinkGeneral = 'https://api.whatsapp.com/send/?phone=554185113433&text=Olá!+Estava+buscando+uma+contadora+e+encontrei+seu+site.+Pode+me+ajudar?';

  const handleConversion = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = e.currentTarget.href;
    // Fire Google Ads conversion event
    try {
      const fn = (window as unknown as Record<string, unknown>).gtag_report_conversion;
      if (typeof fn === 'function') {
        (fn as () => void)();
      }
    } catch (_) {
      // silent fallback
    }
    // Open WhatsApp in a new tab
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 max-w-7xl mx-auto">
            <div className="flex items-center flex-shrink-0">
              <img
                alt="Ana Fortes Contabilidade"
                className="h-10 sm:h-12 w-auto"
                src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/b65bab23ffbc8fdf41293e6a9fbe878f.png"
              />
            </div>
            <nav className="hidden md:flex items-center space-x-6 lg:space-x-8">
              <a href="#inicio" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap">
                Início
              </a>
              <a href="#servicos" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap">
                Serviços
              </a>
              <a href="#sobre" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap">
                Sobre
              </a>
              <a href="#depoimentos" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap">
                Depoimentos
              </a>
              <a href="#contato" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap">
                Contato
              </a>
            </nav>
            <div className="hidden xl:flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <i className="ri-phone-line text-blue-600"></i>
                <span className="whitespace-nowrap">(41) 98511-3433</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <i className="ri-mail-line text-blue-600"></i>
                <span className="whitespace-nowrap">ana@contadoraemcuritiba.com.br</span>
              </div>
              <a
                href={whatsappLinkGeneral}
                    onClick={handleConversion}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-whatsapp-line mr-2"></i>WhatsApp
              </a>
            </div>
            <a
              href={whatsappLinkGeneral}
                    onClick={handleConversion}
              className="md:hidden bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap text-sm flex items-center"
            >
              <i className="ri-whatsapp-line"></i>
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/9c3e4913597f85024a620464766892f3.jpg)' }}></div>
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-800/80 to-gray-900/70"></div>
        <div className="w-full px-4 sm:px-6 lg:px-8 relative z-10 py-16 sm:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
                <div className="space-y-4 sm:space-y-6">
                  <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight">
                    Desenquadramento do MEI em Curitiba
                    <span className="text-teal-300 block mt-2">com Segurança Fiscal</span>
                  </h1>
                  <p className="text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                    Fazemos o processo de saída do MEI e orientamos o novo enquadramento para evitar riscos e impostos incorretos.
                  </p>
                  <ul className="space-y-2 sm:space-y-3 text-gray-200 text-sm sm:text-base max-w-xl mx-auto lg:mx-0">
                    <li className="flex items-center space-x-3 justify-center lg:justify-start">
                      <i className="ri-check-line text-teal-400 text-lg sm:text-xl flex-shrink-0"></i>
                      <span>Diagnóstico do seu caso</span>
                    </li>
                    <li className="flex items-center space-x-3 justify-center lg:justify-start">
                      <i className="ri-check-line text-teal-400 text-lg sm:text-xl flex-shrink-0"></i>
                      <span>Comunicação e procedimentos do desenquadramento</span>
                    </li>
                    <li className="flex items-center space-x-3 justify-center lg:justify-start">
                      <i className="ri-check-line text-teal-400 text-lg sm:text-xl flex-shrink-0"></i>
                      <span>Definição do novo enquadramento</span>
                    </li>
                    <li className="flex items-center space-x-3 justify-center lg:justify-start">
                      <i className="ri-check-line text-teal-400 text-lg sm:text-xl flex-shrink-0"></i>
                      <span>Rotina contábil após a migração</span>
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl text-sm sm:text-base"
                  >
                    <i className="ri-whatsapp-line mr-2 text-lg sm:text-xl"></i>Falar no WhatsApp
                  </a>
                </div>
                <p className="text-xs sm:text-sm text-gray-300 text-center lg:text-left">
                  <i className="ri-map-pin-line mr-1"></i>
                  Atendimento em Curitiba e Região Metropolitana
                </p>
              </div>
              <div className="relative hidden lg:block">
                <div className="relative z-10">
                  <img
                    alt="Desenquadramento do MEI"
                    className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                    src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/ca785a176c61b1e5a41bd567d6164029.jpeg"
                  />
                </div>
                <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-teal-400/30 rounded-full backdrop-blur-sm"></div>
                <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-400/20 rounded-full backdrop-blur-sm"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços para Sair do MEI */}
      <section id="servicos" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <div className="inline-flex items-center px-4 py-2 bg-teal-100 text-teal-800 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
                <i className="ri-service-line mr-2"></i>Serviços Especializados
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
                Serviços para
                <span className="text-teal-600 block mt-2">Sair do MEI</span>
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                Processo completo de desenquadramento com orientação especializada para garantir sua regularização fiscal.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Diagnóstico MEI */}
              <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-gray-100">
                <div className="space-y-4 sm:space-y-6">
                  <div className="space-y-4">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-xl flex items-center justify-center mx-auto sm:mx-0">
                      <i className="ri-search-line text-teal-600 text-xl sm:text-2xl"></i>
                    </div>
                    <div className="text-center sm:text-left">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Diagnóstico MEI</h3>
                      <p className="text-gray-600 text-sm sm:text-base">
                        Análise completa do faturamento, atividade e obrigações para identificar a necessidade de desenquadramento.
                      </p>
                    </div>
                  </div>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Verificação de faturamento</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Análise de atividade permitida</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Levantamento de pendências</span>
                    </li>
                  </ul>
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-lg font-semibold text-gray-900 mb-4 text-center sm:text-left">Valores sob consulta</p>
                    <a
                      href={whatsappLink}
                    onClick={handleConversion}
                      className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-gray-100 text-gray-900 hover:bg-gray-200 text-sm sm:text-base"
                    >
                      <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                    </a>
                  </div>
                </div>
              </div>

              {/* Desenquadramento do MEI */}
              <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-teal-200 ring-2 ring-teal-100">
                <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-teal-600 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap">Mais Procurado</span>
                </div>
                <div className="space-y-4 sm:space-y-6 mt-2 sm:mt-0">
                  <div className="space-y-4">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-xl flex items-center justify-center mx-auto sm:mx-0">
                      <i className="ri-file-list-line text-teal-600 text-xl sm:text-2xl"></i>
                    </div>
                    <div className="text-center sm:text-left">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Desenquadramento do MEI</h3>
                      <p className="text-gray-600 text-sm sm:text-base">
                        Execução de todos os procedimentos legais e organização da documentação necessária.
                      </p>
                    </div>
                  </div>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Comunicação oficial do desenquadramento</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Organização de documentação</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Acompanhamento do processo</span>
                    </li>
                  </ul>
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-lg font-semibold text-gray-900 mb-4 text-center sm:text-left">Valores sob consulta</p>
                    <a
                      href={whatsappLink}
                    onClick={handleConversion}
                      className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-teal-600 text-white hover:bg-teal-700 text-sm sm:text-base"
                    >
                      <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                    </a>
                  </div>
                </div>
              </div>

              {/* Contabilidade pós-MEI */}
              <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-gray-100 sm:col-span-2 lg:col-span-1">
                <div className="space-y-4 sm:space-y-6">
                  <div className="space-y-4">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-xl flex items-center justify-center mx-auto sm:mx-0">
                      <i className="ri-calculator-line text-teal-600 text-xl sm:text-2xl"></i>
                    </div>
                    <div className="text-center sm:text-left">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Contabilidade pós-MEI</h3>
                      <p className="text-gray-600 text-sm sm:text-base">
                        Gestão contábil completa após a migração para ME ou Simples Nacional.
                      </p>
                    </div>
                  </div>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Escrituração contábil</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Apuração de impostos</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-teal-500 text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-sm sm:text-sm">Declarações obrigatórias</span>
                    </li>
                  </ul>
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-lg font-semibold text-gray-900 mb-4 text-center sm:text-left">Valores sob consulta</p>
                    <a
                      href={whatsappLink}
                    onClick={handleConversion}
                      className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-gray-100 text-gray-900 hover:bg-gray-200 text-sm sm:text-base"
                    >
                      <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quando é necessário desenquadrar */}
      <section id="quando-desenquadrar" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">
                Quando é necessário desenquadrar
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                Identifique as situações que exigem a saída do MEI para manter sua empresa regularizada
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto sm:mx-0">
                  <i className="ri-money-dollar-circle-line text-teal-600 text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 text-center sm:text-left">Ultrapassou limite de faturamento</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center sm:text-left">
                  Quando o faturamento anual ultrapassa R$ 81.000,00 ou o limite proporcional, é obrigatório o desenquadramento para evitar multas e problemas fiscais.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-amber-100 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto sm:mx-0">
                  <i className="ri-briefcase-line text-amber-600 text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 text-center sm:text-left">Atividade não permitida</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center sm:text-left">
                  Mudança de atividade para uma não permitida no MEI ou necessidade de exercer atividades regulamentadas que exigem outro tipo de empresa.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow sm:col-span-2 lg:col-span-1">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-rose-100 rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto sm:mx-0">
                  <i className="ri-team-line text-rose-600 text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 text-center sm:text-left">Crescimento da estrutura</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center sm:text-left">
                  Necessidade de ter sócios, contratar mais de um funcionário, ou expandir a estrutura empresarial além dos limites do MEI.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Avaliação do desenquadramento */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 px-4 lg:px-0">
                  Solicite uma avaliação do seu MEI
                </h2>
                <p className="text-base sm:text-lg lg:text-xl text-gray-600 px-4 lg:px-0">
                  Converse com a Ana e receba orientação especializada sobre o processo de desenquadramento e os próximos passos.
                </p>
                
                <div className="space-y-4 sm:space-y-6">
                  <div className="flex items-start space-x-4 max-w-xl mx-auto lg:mx-0">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-teal-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Verificação de limite e risco</h3>
                      <p className="text-sm sm:text-base text-gray-600">
                        Análise detalhada do seu faturamento e identificação de possíveis riscos fiscais.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 max-w-xl mx-auto lg:mx-0">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-compass-line text-amber-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Orientação do melhor caminho</h3>
                      <p className="text-sm sm:text-base text-gray-600">
                        Definição do regime tributário mais adequado: ME, Simples Nacional ou outro conforme seu caso.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4 max-w-xl mx-auto lg:mx-0">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-list-3-line text-rose-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Checklist de obrigações</h3>
                      <p className="text-sm sm:text-base text-gray-600">
                        Lista completa de todas as obrigações e procedimentos necessários após a migração.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-6 sm:p-8 text-white">
                <div className="text-center">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                    <i className="ri-whatsapp-line text-white text-3xl sm:text-4xl"></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">Fale agora com a Ana</h3>
                  <p className="text-sm sm:text-base text-teal-100 mb-6 sm:mb-8 px-4">
                    Tire suas dúvidas sobre o desenquadramento do MEI e receba uma proposta personalizada.
                  </p>
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="bg-white text-teal-700 hover:bg-teal-50 font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full justify-center text-sm sm:text-base"
                  >
                    <i className="ri-whatsapp-line text-lg sm:text-xl"></i>Falar no WhatsApp
                  </a>
                  <p className="text-teal-200 text-xs sm:text-sm mt-4">
                    <i className="ri-time-line mr-1"></i>Resposta em até 2 horas
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre a Ana Fortes */}
      <section id="sobre" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="relative order-2 lg:order-1">
                <div className="relative z-10 max-w-md mx-auto lg:max-w-none">
                  <img
                    alt="Ana Fortes - Contadora Especialista em Desenquadramento de MEI"
                    className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                    src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/ca785a176c61b1e5a41bd567d6164029.jpeg"
                  />
                </div>
                <div className="hidden lg:block absolute -bottom-6 -left-6 w-24 h-24 bg-teal-400/20 rounded-full backdrop-blur-sm"></div>
                <div className="hidden lg:block absolute -top-6 -right-6 w-32 h-32 bg-amber-400/20 rounded-full backdrop-blur-sm"></div>
              </div>

              <div className="space-y-6 sm:space-y-8 order-1 lg:order-2 text-center lg:text-left">
                <div className="space-y-4 sm:space-y-6">
                  <div className="inline-flex items-center px-4 py-2 bg-teal-100 text-teal-800 rounded-full text-xs sm:text-sm font-medium">
                    <i className="ri-user-star-line mr-2"></i>Sobre a Ana Fortes
                  </div>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight px-4 lg:px-0">
                    Sua Contadora de
                    <span className="text-teal-600 block mt-2">Confiança</span>
                  </h2>
                  <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed px-4 lg:px-0">
                    Especialista em desenquadramento de MEI e regularização empresarial em Curitiba. Ajudo empreendedores a migrarem do MEI com segurança fiscal e orientação completa sobre o novo enquadramento.
                  </p>
                </div>

                <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto lg:mx-0">
                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-award-line text-teal-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">CRC Ativo</h4>
                      <p className="text-gray-600 text-xs sm:text-sm">Registro profissional ativo no CRC</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-amber-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">5+ Anos</h4>
                      <p className="text-gray-600 text-xs sm:text-sm">Experiência em regularização de MEI</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-team-line text-rose-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">100+ Clientes</h4>
                      <p className="text-gray-600 text-xs sm:text-sm">Empresas regularizadas com sucesso</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-teal-600 text-lg sm:text-xl"></i>
                    </div>
                    <div className="text-left">
                      <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Curitiba</h4>
                      <p className="text-gray-600 text-xs sm:text-sm">Atendimento em toda a região</p>
                    </div>
                  </div>
                </div>

                <div className="pt-4 flex justify-center lg:justify-start">
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl text-sm sm:text-base"
                  >
                    <i className="ri-chat-3-line mr-2"></i>Falar com a Ana
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Planos de contabilidade após sair do MEI */}
      <section id="planos" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">
                Planos de contabilidade após sair do MEI
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                Escolha o plano ideal para o seu novo momento empresarial após o desenquadramento
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Para Microempresas */}
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105 ring-2 ring-teal-500">
                <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-teal-600 text-white px-3 py-1 rounded-full text-xs font-semibold z-10 whitespace-nowrap">
                  Mais Comum
                </div>
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    alt="Para Microempresas"
                    className="w-full h-full object-cover object-top"
                    src="https://readdy.ai/api/search-image?query=Small%20business%20team%20working%20in%20modern%20office%2C%20professional%20workspace%20with%20computers%20and%20documents%2C%20collaborative%20environment%2C%20bright%20natural%20lighting%2C%20business%20growth%20concept&width=400&height=300&seq=sol2&orientation=landscape"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
                    <h3 className="text-base sm:text-xl font-bold">Para Microempresas</h3>
                    <p className="text-xs sm:text-sm opacity-90">Simples Nacional</p>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                    Gestão completa para empresas que faturam até R$ 4,8 milhões.
                  </p>
                  <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Contabilidade completa</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Folha de pagamento</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Declarações obrigatórias</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Consultoria tributária</span>
                    </li>
                  </ul>
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block bg-teal-600 hover:bg-teal-700 text-white text-sm sm:text-base"
                  >
                    Solicitar proposta
                  </a>
                </div>
              </div>

              {/* Para Pequenas Empresas - Lucro Presumido */}
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    alt="Para Pequenas Empresas"
                    className="w-full h-full object-cover object-top"
                    src="https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20in%20modern%20conference%20room%2C%20executives%20discussing%20financial%20reports%2C%20corporate%20environment%2C%20strategic%20planning%20session%2C%20professional%20lighting&width=400&height=300&seq=sol3&orientation=landscape"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
                    <h3 className="text-base sm:text-xl font-bold">Para Pequenas Empresas</h3>
                    <p className="text-xs sm:text-sm opacity-90">Lucro Presumido</p>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                    Soluções estratégicas para empresas em crescimento.
                  </p>
                  <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Planejamento tributário</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Análise de viabilidade</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Gestão financeira avançada</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Relatórios gerenciais</span>
                    </li>
                  </ul>
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block border border-teal-600 text-teal-600 hover:bg-teal-50 text-sm sm:text-base"
                  >
                    Solicitar proposta
                  </a>
                </div>
              </div>

              {/* Consultoria Personalizada */}
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105 sm:col-span-2 lg:col-span-1">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    alt="Consultoria Personalizada"
                    className="w-full h-full object-cover object-top"
                    src="https://public.readdy.ai/ai/img_res/435e9ee47f165ec0c43aefe30cfea26b.jpg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white">
                    <h3 className="text-base sm:text-xl font-bold">Consultoria Personalizada</h3>
                    <p className="text-xs sm:text-sm opacity-90">Conforme seu caso</p>
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                    Soluções sob medida para casos específicos e complexos.
                  </p>
                  <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Análise detalhada do caso</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Definição do melhor regime</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Planejamento tributário</span>
                    </li>
                    <li className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-check-line text-teal-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>
                      <span>Suporte especializado</span>
                    </li>
                  </ul>
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block border border-teal-600 text-teal-600 hover:bg-teal-50 text-sm sm:text-base"
                  >
                    Solicitar proposta
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Intermediário */}
      <section className="py-12 sm:py-16 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 px-4">Regularize sua situação e evite problemas</h2>
            <p className="text-teal-100 mb-6 sm:mb-8 text-base sm:text-lg px-4">
              Entre em contato e receba orientação completa sobre o desenquadramento do MEI e o melhor plano para sua empresa.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
              <a
                href={whatsappLink}
                    onClick={handleConversion}
                className="inline-flex items-center bg-white text-teal-700 hover:bg-teal-50 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base w-full sm:w-auto justify-center"
              >
                <i className="ri-whatsapp-line mr-2 text-lg sm:text-xl"></i>Fale no WhatsApp
              </a>
              <div className="text-teal-100 text-xs sm:text-sm">
                <i className="ri-map-pin-line mr-1"></i>Curitiba e Região Metropolitana
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section id="depoimentos" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">O que dizem nossos clientes</h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                Depoimentos reais de empreendedores que regularizaram suas empresas conosco
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
                <div className="flex justify-center space-x-1 mb-4 sm:mb-6">
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                </div>
                <p className="text-gray-600 leading-relaxed text-center mb-4 sm:mb-6 text-sm sm:text-base">
                  "Atendimento humano faz toda a diferença. Rodei por algumas opções que só tinha chatbot atendendo. Responde rapidamente e faz questão de explicar tudo muito bem. Super agilizada e eficiente."
                </p>
                <div className="text-center">
                  <h5 className="font-bold text-gray-900 text-sm sm:text-base">Wellington Johann</h5>
                  <p className="text-gray-500 text-xs sm:text-sm">Empreendedor - Curitiba</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
                <div className="flex justify-center space-x-1 mb-4 sm:mb-6">
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                  <i className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                </div>
                <p className="text-gray-600 leading-relaxed text-center mb-4 sm:mb-6 text-sm sm:text-base">
                  "Quero agradecer a Ana pelo ótimo trabalho que vem fazendo na contabilidade da minha empresa. Gosto muito da agilidade e clareza nas informações. Está sendo essencial para organizar a parte financeira da empresa."
                </p>
                <div className="text-center">
                  <h5 className="font-bold text-gray-900 text-sm sm:text-base">Ariane Cordeiro</h5>
                  <p className="text-gray-500 text-xs sm:text-sm">Empresária - Curitiba</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section id="contato" className="py-12 sm:py-16 lg:py-20 bg-gray-900">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 px-4">Precisa sair do MEI com segurança?</h2>
            <p className="text-gray-300 mb-6 sm:mb-8 text-base sm:text-lg max-w-2xl mx-auto px-4">
              Junte-se aos empreendedores que já regularizaram suas empresas e têm uma contabilidade que realmente funciona.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6 px-4">
              <a
                href={whatsappLink}
                    onClick={handleConversion}
                className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto justify-center"
              >
                <i className="ri-whatsapp-line mr-2 text-lg sm:text-xl"></i>Falar no WhatsApp
              </a>
              <a
                href="tel:+5541985113433"
                className="inline-flex items-center text-gray-300 hover:text-white transition-colors cursor-pointer text-sm sm:text-base"
              >
                <i className="ri-phone-line mr-2"></i>(41) 98511-3433
              </a>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm">
              <i className="ri-map-pin-line mr-1"></i>Curitiba e Região Metropolitana
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="py-8 sm:py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
              <div className="text-center sm:text-left">
                <div className="flex items-center justify-center sm:justify-start space-x-2 mb-4 sm:mb-6">
                  <img
                    alt="Ana Fortes Contabilidade"
                    className="h-10 sm:h-12 w-auto"
                    src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/bf817876b8311f8ff357e13dc34ba1ee.png"
                  />
                </div>
                <p className="text-gray-400 mb-4 sm:mb-6 leading-relaxed text-xs sm:text-sm">
                  Especialista em desenquadramento de MEI e regularização empresarial em Curitiba.
                </p>
                <div className="flex space-x-3 justify-center sm:justify-start">
                  <a
                    href={whatsappLink}
                    onClick={handleConversion}
                    className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-white"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/anafortes.contadora"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-pink-500 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-instagram-line text-white"></i>
                  </a>
                  <a
                    href="mailto:ana@contadoraemcuritiba.com.br"
                    className="w-10 h-10 bg-gray-600 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                  >
                    <i className="ri-mail-line text-white"></i>
                  </a>
                </div>
              </div>

              <div className="text-center sm:text-left">
                <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Serviços</h4>
                <ul className="space-y-2 text-xs sm:text-sm">
                  <li>
                    <a href="#servicos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Diagnóstico MEI
                    </a>
                  </li>
                  <li>
                    <a href="#servicos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Desenquadramento do MEI
                    </a>
                  </li>
                  <li>
                    <a href="#servicos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Contabilidade pós-MEI
                    </a>
                  </li>
                  <li>
                    <a href="#planos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Consultoria Tributária
                    </a>
                  </li>
                </ul>
              </div>

              <div className="text-center sm:text-left">
                <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Links Rápidos</h4>
                <ul className="space-y-2 text-xs sm:text-sm">
                  <li>
                    <a href="#inicio" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Início
                    </a>
                  </li>
                  <li>
                    <a href="#quando-desenquadrar" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Quando Sair do MEI
                    </a>
                  </li>
                  <li>
                    <a href="#sobre" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Sobre
                    </a>
                  </li>
                  <li>
                    <a href="#planos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      Planos
                    </a>
                  </li>
                </ul>
              </div>

              <div className="text-center sm:text-left">
                <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Contato</h4>
                <div className="space-y-3 text-xs sm:text-sm">
                  <div className="flex items-center space-x-3 justify-center sm:justify-start">
                    <i className="ri-map-pin-line text-teal-400 flex-shrink-0"></i>
                    <span className="text-gray-400">Curitiba e Região Metropolitana</span>
                  </div>
                  <div className="flex items-center space-x-3 justify-center sm:justify-start">
                    <i className="ri-phone-line text-teal-400 flex-shrink-0"></i>
                    <a href="tel:+5541985113433" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                      (41) 98511-3433
                    </a>
                  </div>
                  <div className="flex items-center space-x-3 justify-center sm:justify-start">
                    <i className="ri-mail-line text-teal-400 flex-shrink-0"></i>
                    <a href="mailto:ana@contadoraemcuritiba.com.br" className="text-gray-400 hover:text-white transition-colors cursor-pointer break-all">
                      ana@contadoraemcuritiba.com.br
                    </a>
                  </div>
                </div>

                <div className="mt-4 bg-gray-700 rounded-lg p-3 sm:p-4">
                  <h5 className="font-semibold mb-2 text-xs sm:text-sm flex items-center justify-center sm:justify-start">
                    <i className="ri-time-line text-teal-400 mr-2"></i>Horário
                  </h5>
                  <div className="space-y-1 text-xs text-gray-400 text-center sm:text-left">
                    <p>Seg a Sex: 8h às 18h</p>
                    <p>WhatsApp 24h para urgências</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-700 py-4 sm:py-6">
              <div className="flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4 text-center">
                <p className="text-gray-500 text-xs sm:text-sm">© 2025 Ana Fortes Contabilidade. Todos os direitos reservados.</p>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-white transition-colors cursor-pointer text-xs sm:text-sm"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp Floating Button */}
        <div className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 z-50">
          <a
            href={whatsappLink}
                    onClick={handleConversion}
            className="bg-green-500 hover:bg-green-600 text-white w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer animate-pulse"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}
